var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9218 10.4081L37.9218 4.40811C37.7128 4.19835 37.4644 4.03192 37.1909 3.91836C36.9174 3.8048 36.6242 3.74634 36.3281 3.74634C36.0319 3.74634 35.7387 3.8048 35.4652 3.91836C35.1917 4.03192 34.9434 4.19835 34.7343 4.40811L16.7343 22.4081C16.3139 22.831 16.0785 23.4036 16.08 24V30C16.08 30.5967 16.317 31.169 16.739 31.591C17.1609 32.0129 17.7332 32.25 18.33 32.25H24.33C24.6255 32.2502 24.9182 32.1922 25.1914 32.0793C25.4645 31.9664 25.7127 31.8007 25.9218 31.5919L43.9218 13.5919C44.131 13.3829 44.297 13.1347 44.4102 12.8616C44.5234 12.5885 44.5817 12.2957 44.5817 12C44.5817 11.7043 44.5234 11.4115 44.4102 11.1384C44.297 10.8652 44.131 10.6171 43.9218 10.4081ZM36.33 9.18749L39.1425 12L37.08 14.0625L34.2675 11.25L36.33 9.18749ZM23.3925 27.75H20.58V24.9375L31.08 14.4375L33.8925 17.25L23.3925 27.75ZM43.08 24.8569V39C43.08 39.9945 42.6849 40.9484 41.9816 41.6516C41.2783 42.3549 40.3245 42.75 39.33 42.75H9.32996C8.33539 42.75 7.38157 42.3549 6.67831 41.6516C5.97504 40.9484 5.57996 39.9945 5.57996 39V8.99999C5.57996 8.00543 5.97504 7.0516 6.67831 6.34834C7.38157 5.64508 8.33539 5.24999 9.32996 5.24999H23.4731C24.0698 5.24999 24.6421 5.48704 25.0641 5.909C25.486 6.33095 25.7231 6.90325 25.7231 7.49999C25.7231 8.09672 25.486 8.66902 25.0641 9.09098C24.6421 9.51293 24.0698 9.74999 23.4731 9.74999H10.08V38.25H38.58V24.8569C38.58 24.2601 38.817 23.6878 39.239 23.2659C39.6609 22.8439 40.2332 22.6069 40.83 22.6069C41.4267 22.6069 41.999 22.8439 42.4209 23.2659C42.8429 23.6878 43.08 24.2601 43.08 24.8569Z",
    fill: "url(#paint0_linear_1559_2707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_2707",
    x1: 25.0808,
    y1: 3.74634,
    x2: 25.0808,
    y2: 42.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotePencil);
export default __webpack_public_path__ + "static/media/NotePencil.e63e437f03c06bbf57a1ec5abb72bc61.svg";
export { ForwardRef as ReactComponent };